
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">{{dialogTitle}}</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div><div class="font-weight-bold">Customer</div>{{customerName}}</div>
    <div class="my-3"><div class="font-weight-bold">Environment</div>{{environmentName}}</div>
    <div class="my-3"><div class="font-weight-bold">Corporation</div>{{corporationName||'Not Selected'}}</div>
    <div >Are you sure you want to perform the sync operation?</div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="sync()">{{confirmButtonText}}</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
  </div>
</div>





